import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Paper, Button, CircularProgress, Zoom } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
//import Button from '@material-ui/core/Button';
import FMPTextField from '../../components/ui/FMPTextField';
import GreenChecked from '../../images/icons/greenChecked.svg';
// import CheckIcon from '@material-ui/icons/CheckCircle';

import PricingRequestContainer from '../../containers/retailPricing/PricingRequest';

const styles = (theme) => {
	//const primaryColor = theme.palette.primary[500];
	return {
		note: {
			backgroundColor: '#D8F0FF',
			padding: 20,
			fontSize: 16,
			lineHeight: 1.4,
			marginBottom: 10,
			marginTop: 10,
			border: '1px solid #BADEFB',
		},
		lastChange: {
			//border: '2px solid #bbb',
			//backgroundColor: '#f1f1f1',
			backgroundColor: '#D8F0FF',
			border: '1px solid #BADEFB',
			borderRadius: 4,
			padding: 20,
			fontSize: 16,
			lineHeight: 1.4,
			marginBottom: 10,
			marginTop: 20,
		},
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 10,
			[theme.breakpoints.up('md')]: {
				padding: '10px 10px 10px 10px',
			},
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		orderDetails: {
			paddingTop: 40,
			fontSize: 24,
			fontWeight: 300,
			borderBottom: '1px solid #ddd',
		},
		infoSection: {
			paddingTop: 20,
			lineHeight: 1.4,
		},
		check: {
			color: '#4CAF50',
			width: 40,
			height: 40,
			verticalAlign: 'middle',
			paddingRight: 5,
		},
		confirmedTitle: {
			fontSize: 24,
			fontWeight: 500,
			padding: 20,
		},
		confirmedMessage: {
			padding: 20,
			lineHeight: 1.4,
			fontSize: 16,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
		isSaving: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
		},
		savingSuccessful: {
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
	};
};

class SubmitMultiSitePricing extends Component {
	constructor(props) {
		super(props);
		const lookupUid = _.get(this.props, ['match', 'params', 'lookupUid']);

		this.state = {
			lookupUid,
			errors: [],
			infoSection: undefined,
			formFieldError: {},
			isSaving: false,
			isSent: false,
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { publicGetPricingRequest, pricingRequest } = this.props;
		const { lookupUid } = this.state;

		if (!pricingRequest) {
			publicGetPricingRequest({
				params: {
					lookupUid,
				},
				callback: (err, r) => {
					if (err) {
						return this.setState({ errors: [err] });
					}
					const pricingRequest = _.get(r, 'collections.pricingRequestCollection.0');
					if (!pricingRequest) {
						return this.setState({ errors: ['Missing info section'] });
					}
					return this.setState({ pricingRequest });
				},
			});
		}
	}

	handleSubmit = () => {
		const { showErrors, publicSubmitPricing } = this.props;
		const { lookupUid } = this.state;

		const stationsToAskForPricing = this.getStationsForPricing();
		if (!stationsToAskForPricing) {
			return showErrors('Missing multiStationIds and stationId on the pricing request');
		}

		const params = {
			lookupUid,
			stationPrices: [],
		};

		//- Required fields
		const formFieldError = {};
		stationsToAskForPricing.forEach((station) => {
			const key = `station_${station.stationId}`;
			const val = this.state[key];
			if (!val) {
				// We don't require all prices
				//formFieldError[key] = `Price for ${station.number} is required`;
				return;
			}

			if (!val.match(/^\d*\.?\d*$/)) {
				formFieldError[key] =
					'Price should only contain numbers and a decimal (period). Example: 2.79';
				return;
			}

			const price = parseFloat(val);
			if (!_.isNumber(price) || _.isNaN(price)) {
				formFieldError[key] = 'Price should be a decimal number like 2.79';
			}

			if (price < 0.99 || price >= 6.999) {
				formFieldError[key] = 'Invalid price. Must be between .99 and 6.99. Example: 2.799';
				return;
			}
			params.stationPrices.push({
				stationId: station.stationId,
				price,
			});
		});

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		if (_.isEmpty(params.stationPrices)) {
			showErrors(['At least one price is required']);
			return;
		}

		this.setState({
			isSaving: true,
		});

		publicSubmitPricing({
			params,
			callback: (err) => {
				this.setState({
					isSaving: false,
				});
				if (err) {
					showErrors([err]);
					return;
				}
				this.setState({
					isSent: true,
				});
			},
		});
	};

	onChange = (event, fieldName, index, attr) => {
		if (!_.isNumber(index)) {
			this.setState({ [fieldName]: event.target.value });
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}
			this.setState({ [fieldName]: inputs });
		}
	};

	getStationsForPricing = () => {
		const { stationMap } = this.props;
		const { pricingRequest } = this.state;
		if (!pricingRequest) {
			return [];
		}

		// Multi vs single
		const stationsToAskForPricing = [];
		if (pricingRequest.multiStationIds) {
			pricingRequest.multiStationIds.forEach((stationId) => {
				const station = stationMap[stationId] || { number: '', name: 'Missing station' };

				// Filter out stations that have SMS disabled or are inactive
				if (station.smsPricingIsDisabled || station.stationIsNotActive) {
					return; // Skip this station
				}

				stationsToAskForPricing.push(station);
			});
		} else if (pricingRequest.stationId) {
			const station = stationMap[pricingRequest.stationId] || {
				number: '',
				name: 'Missing station',
			};
			stationsToAskForPricing.push(station);
		} else {
			return null;
		}
		return stationsToAskForPricing;
	};

	render() {
		const { classes } = this.props;
		const { pricingRequest } = this.state;
		const { isSaving, isSent } = this.state;

		if (!pricingRequest) {
			return <div>Fetching pricing request...</div>;
		}

		// Multi vs single
		const stationsToAskForPricing = this.getStationsForPricing();
		if (!stationsToAskForPricing) {
			return <div>Missing multiStationIds and stationId on the pricing request</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography variant="h5" align="left" gutterBottom>
								Station Cash Pricing
							</Typography>
						</Grid>
					</Grid>
					<Paper className={classes.paper}>
						<div className={classes.note}>
							This pricing request is intended for{' '}
							<strong>{pricingRequest.sentToRecipient}.</strong>
							&nbsp;If you have received this order in error please contact{' '}
							<a href="mailto:dispatch@pearsonfuels.com">dispatch@pearsonfuels.com</a> or call
							833-385-3835.
							<br />
							<br />
							<strong>NOTE:</strong> If you don&apos;t know all the prices, please just fill out
							pricing for the stations you know and submit.
						</div>
						{_.isEmpty(stationsToAskForPricing) && (
							<div className={classes.infoSection}>
								No stations to ask for pricing. Perhaps they were marked inactive after the SMS
								request was sent?
								<br />
								Please contact dispatch@pearsonfuels.com if you have any questions.
							</div>
						)}

						<div className={classes.infoSection}>
							{stationsToAskForPricing.map((station) => {
								return this.renderStation({ station });
							})}
						</div>

						<Zoom
							in={isSaving}
							style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>

						<Zoom in={isSent} style={{ transitionDelay: isSent ? '250ms' : '0ms' }}>
							<div className={classes.savingSuccessful}>
								<div className={classes.greenCheckedIcon} />
								<span style={{ paddingLeft: 10 }}>Prices submitted successfully! Thank you!</span>
							</div>
						</Zoom>

						<div style={{ paddingTop: 1 }}>
							<Button
								disabled={isSaving || isSent}
								variant="contained"
								color="primary"
								className={classes.submitButton}
								onClick={this.handleSubmit}
							>
								Submit Prices
							</Button>
						</div>
					</Paper>
				</Grid>
			</Grid>
		);
	}

	renderStation = ({ station }) => {
		return (
			<div
				key={station.stationId}
				style={{ marginBottom: 20, paddingBottom: 20, borderBottom: '1px solid #eee' }}
			>
				<div style={{ fontSize: '110%', fontWeight: '600' }}>
					{station.number} - {station.name}
				</div>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<span style={{ marginRight: 7 }} role="img" aria-label="arrow">
						➡️
					</span>
					<FMPTextField
						name={`station_${station.stationId}`}
						label={`Cash Price`}
						controller={this}
						helpText={'Include as many decimals as needed (Example: 2.999)'}
					/>
				</div>
			</div>
		);
	};
}

SubmitMultiSitePricing.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func,
	publicSubmitPricing: PropTypes.func.isRequired,
	publicGetPricingRequest: PropTypes.func.isRequired,
	pricingRequest: PropTypes.object,
	stationMap: PropTypes.object,
};

export default _.flow([withStyles(styles), PricingRequestContainer])(SubmitMultiSitePricing);
